import { useState, useEffect } from 'react';

const STORAGE_KEYS = {
  projects: 'recently_viewed_projects',
  properties: 'recently_viewed_properties',
};

const getFromStorage = (type) => {
  const data = localStorage.getItem(STORAGE_KEYS[type]);
  return data ? JSON.parse(data) : [];
};

const saveToStorage = (type, items) => {
  localStorage.setItem(STORAGE_KEYS[type], JSON.stringify(items));
};

export function useRecentlyViewed(type) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getFromStorage(type));
  }, [type]);

  const addItem = (item) => {
    setItems((current) => {
      const filtered = current.filter(i => i.id !== item.id);
      const updated = [item, ...filtered].slice(0, 5);
      saveToStorage(type, updated);
      return updated;
    });
  };

  const removeItem = (id) => {
    setItems((current) => {
      const updated = current.filter(i => i.id !== id);
      saveToStorage(type, updated);
      return updated;
    });
  };

  const clearAll = () => {
    localStorage.removeItem(STORAGE_KEYS[type]);
    setItems([]);
  };

  return {
    items,
    addItem,
    removeItem,
    clearAll,
  };
}
